import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from '../../../Shared/Icon/Icon'

function ProductAnalyticsTermsModal({ modalIsOpen, agreeToTerms, closeModal }) {
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={() => closeModal()}>
          <Icon type="times" color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--product-analytics-terms">
          <div className="row">
            <div className="col-10 offset-1">
              <h2 className="content-heading__h2">
                CGTrader Analytics Terms of Service
              </h2>
              <p>Without any prejudice to General Terms and Conditions, the Seller agrees to keep all uploaded Content
                available on CGTrader for licensing (sale or free download) for the period of 12 months after signing
                the agreement, however, this does not in any way limit the right of the Seller to also grant similar
                license rights to other parties through other channels during this period. By agreeing to participate
                in the Analytics program, the Seller shall gain access to the following features free of charge:
              </p>
              <p>(i) Access to exclusive real-time data about market trends, top keywords, category and conversion
                analysis, and other statistics;<br />
                (ii) Access to detailed analyses of the Seller's own model library and sales performance data, including
                page-views, conversion, price suggestions, and other data;
              </p>
              <p>The Seller shall have no right to terminate the agreement before the end of the agreed period of 12
                month. The Seller must inform CGTrader at least 6 months before terminating the agreement. The Seller
                agrees to properly exercise the provisions of the General Terms and Conditions regulating the obligations,
                license rights and payment processing of the Seller, including all other provisions of the General Terms
                and Conditions (excluding par. 20.8 and provisions regarding the termination of the agreement) during
                this period. The specified termination of the agreement means opting out of the program and does not
                include erasure of the profile. The erasure of profile procedure is set and performed in accordance with
                General Terms and Conditions. The provided term of 6 months to opt out of the program is not applicable
                in cases where the failure of CGTrader to perform the agreement or the defective performance thereof is
                considered to be an essential violation of the agreement.
              </p>
              <p className="overlay-modal__footer">
                <button className="btn btn-primary" onClick={() => agreeToTerms()}>Agree & Continue</button>
              </p>
            </div>
          </div>

        </div>
      </div>
    </Modal>
  )
}

ProductAnalyticsTermsModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  agreeToTerms: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default ProductAnalyticsTermsModal
